import React, { useCallback, useState } from 'react';
import { useDialogTree } from '../context';

import DialogTreeComponent from '../index';
import DeleteNodeConfirmationModal from '../../components/deleteNodeConfirmationModal';
import { button_style } from 'views/IVR/form/tree/node/styles';
import { delete_icon_style } from 'views/IVR/form/tree/node/styles';
import { add_icon_style } from 'views/IVR/form/tree/node/styles';
import { validateNode } from '../context/helpers';

const nameStyle = {
  fontFamily: 'Open Sans, sans-serif',
  fontSize: '1rem',
  fontWeight: '400',
  lineHeight: '1.5',
  color: '#525f7f',
  textAlign: 'left'
};

const NodeTree = ({ nodeData }) => {
  const { openModal, nodeActions, linkedNodeId, setLinkedNodeId } =
    useDialogTree();

  const hasData = Object.values(nodeData.action).length > 0;

  const [modalExcludeNode, setModalExcludeNode] = useState(false);

  const verifyIfNodeHasChildren = useCallback(() => {
    return nodeData.nodes && Object.keys(nodeData.nodes).length > 0;
  }, [nodeData]);

  const getDefaultNodeName = (node) => {
    if (
      node.parent?.action.type === 'CONDITIONAL_CHECK' ||
      node.parent?.action.type === 'SUBMENU_BUTTONS'
    ) {
      return 'Senão';
    } else if (
      node.parent?.action.type === 'CREATE_PROTOCOL' ||
      node.parent?.action.type === 'EXECUTE_INTEGRATION' ||
      node.parent?.action.type === 'SEND_AWAIT'
    ) {
      return 'Nó filho';
    } else {
      return 'Nó inicial';
    }
  };

  const getNodeName = () => {
    let name;
    if (!isTheDefaultNode()) {
      name = nodeData?.numericIdentifier
        ? `${nodeData.numericIdentifier} - ${nodeData.stringIdentifier}`
        : nodeData.stringIdentifier.substring(0, 50);
    } else {
      name = getDefaultNodeName(nodeData);
    }
    if (name.length > 55) {
      return `${name.substring(0, 55)}...`;
    }
    return name;
  };

  const isTheDefaultNode = () => {
    return nodeData.isDefault ? true : false;
  };

  const handleNodeActions = (action) => {
    switch (action) {
      case 'ADD_NEW_NODE_CHILD':
        openModal(nodeData, 'ADD_NEW_NODE_CHILD');
        break;
      case 'EDIT_NODE':
        openModal(nodeData, 'EDIT_NODE');
        break;
      case 'DELETE_NODE':
        setModalExcludeNode(true);
        break;
      default:
        break;
    }
  };

  const shouldShowAddButton = () => {
    if (
      nodeData?.action?.type === 'CONDITIONAL_CHECK' ||
      nodeData?.action?.type === 'EE' ||
      nodeData?.action?.type === 'ET' ||
      nodeData?.action?.type === 'TTW' ||
      nodeData?.action?.type === 'RETURN' ||
      nodeData?.action?.type === 'LINKMENU' ||
      nodeData?.action?.type === 'SEND_AWAIT' ||
      nodeData?.action?.type === 'CREATE_PROTOCOL' ||
      nodeData?.action?.type === 'EXECUTE_INTEGRATION'
    )
      return false;
    if (!nodeData?.attributes) return true;
    if (!nodeData?.attributes?.content) return true;
    if (nodeData?.attributes?.content?.substring(0, 5) === 'Áudio') return true;
    return false;
  };

  const shoudShowDeleteButton = () => {
    if (nodeData.level !== 1) {
      return true;
    }
    return false;
  };

  const getActionName = () => {
    if (!nodeData?.action?.type || !nodeActions.length) return '';

    const action = nodeActions.find(
      (action) => action.type === nodeData.action.type
    );

    if (!action) return '';

    return action.description;
  };

  const getColor = () => {
    const validColor = '#cbe8c9';
    const invalidColor = '#f9b6b6';
    const endColor = '#abd4a9';
    const isValid = validateNode(nodeData);

    let color = isValid ? validColor : invalidColor;

    if (linkedNodeId === nodeData?.nodeId) {
      color = '#a2e1ff';
    } else if (
      (isValid && nodeData?.action?.type === 'EE') ||
      nodeData?.action?.type === 'ET' ||
      nodeData?.action?.type === 'TTW'
    ) {
      color = endColor;
    }

    return color;
  };

  return (
    <>
      <div style={{ width: '100%', height: '100%', cursor: 'initial' }}>
        <div
          onMouseEnter={() => {
            setLinkedNodeId(nodeData?.action?.to?.level);
          }}
          onMouseLeave={() => {
            setLinkedNodeId(undefined);
          }}
          style={{
            display: 'flex',
            height: '110px',
            width: '230px',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            padding: '5px 12px 5px 12px',
            flexDirection: 'column',
            borderRadius: '12px',
            boxShadow: `rgba(0, 0, 0, 0.23) 4px 6px 6px 0px`,
            background: getColor()
          }}
        >
          {(hasData || isTheDefaultNode()) && (
            <button
              type="button"
              style={{
                ...button_style,
                position: 'absolute',
                left: '211px',
                bottom: shoudShowDeleteButton()
                  ? shouldShowAddButton()
                    ? '32px'
                    : '13px'
                  : '13px',
                scale: '0.7'
              }}
              onClick={() => openModal(nodeData, 'EDIT_NODE')}
            >
              <i style={{}} className="fas fa-edit"></i>
            </button>
          )}

          {nodeData.level !== 1 && (
            <i
              className="far fa-times-circle"
              style={{
                ...delete_icon_style,
                bottom: shouldShowAddButton() ? '40px' : '20px',
                left: '219px',
                borderRadius: '14px',
                background: '#cbe8c9',
                cursor: 'pointer'
              }}
              onClick={() => {
                handleNodeActions('DELETE_NODE');
              }}
            ></i>
          )}

          {shouldShowAddButton() && (
            <i
              className="fas fa-plus-circle"
              style={{
                ...add_icon_style,
                left: '219px',
                bottom: '20px',
                borderRadius: '14px',
                background: 'white',
                cursor: 'pointer'
              }}
              onClick={() => {
                handleNodeActions('ADD_NEW_NODE_CHILD');
              }}
            ></i>
          )}

          <div style={{ width: '100%' }}>
            <p
              style={{
                ...nameStyle,
                fontSize: '13px',
                marginBottom: '0px',
                width: '100%',
                fontWeight: 'bold'
              }}
            >
              {getNodeName()}{' '}
            </p>
            <p
              style={{
                ...nameStyle,
                fontSize: '13px',
                marginBottom: '0px',
                width: '100%'
              }}
            >
              {getActionName()}
            </p>
          </div>
        </div>
      </div>
      {verifyIfNodeHasChildren() && (
        <>
          <ul>
            <DialogTreeComponent data={nodeData.nodes || {}} />
          </ul>
        </>
      )}

      <DeleteNodeConfirmationModal
        isModalOpen={modalExcludeNode}
        onModalToggle={setModalExcludeNode}
        nodeData={nodeData}
        nodeHasChildren={verifyIfNodeHasChildren()}
      />
    </>
  );
};

export default NodeTree;
